import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ExpenseTypeModel } from '../model/expense-type.model';
import { ExpenseTypeService } from '../expense-type.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { PermissionService } from 'src/app/auth/permission.service';
@Component({
  selector: 'app-expense-type-edit',
  templateUrl: './expense-type-edit.component.html',
  styleUrls: ['./expense-type-edit.component.scss'],
  standalone: false
})
export class ExpenseTypeEditComponent implements DirtyCheck {
  editForm!: FormGroup;
  expenseInfo: ExpenseTypeModel = {};
  isFormDirty: boolean = false;
  ratingList: ExpenseTypeModel[] = [];
  expenseType: any;
  permission: any;

  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private expenseTypeService: ExpenseTypeService,
    private snackBarService: SnackBarService,
    private permissionService: PermissionService,
    public dialog: MatDialog,) {

    let expenseId = this.route.snapshot.paramMap.get('id');


    if (expenseId !== null && parseInt(expenseId) !== 0) {
      this.setExpenseInfo(expenseId);
    }
    this.initForm();
    //  this.getExpenseType();
    this.permission = permissionService.getPagePermission("expense");

  }
  ngOnInit(): void {
    //  this.loadRating();  
  }

  getExpenseType() {
    let requestData = {
      "search": {
        "filters": {
          "simpleSearch": [],
          "advSearch": [],
          "scope": {
            "limit": 10,
            "offset": 0
          }
        },
        "sort": [
          {
            "column": "name",
            "order": "asc"
          }
        ]
      }
    }
    this.expenseTypeService.getExpenseType(requestData).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.expenseType = response.data.expenses_type;
          this.initForm();
        }
      },
      error: (error) => {
        let snackBarData: SnackBarData = {
          message: 'Failed to get expense type from server. Connection to the server failed.',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }
  initForm() {
    this.editForm = this.builder.group({
      code: this.builder.control(this.expenseInfo.code, [Validators.required, Validators.maxLength(10)]),
      name: this.builder.control(this.expenseInfo.name, [Validators.required, Validators.maxLength(50)]),
      short_name: this.builder.control(this.expenseInfo.short_name, [Validators.required, Validators.maxLength(50)]),
      gl_acc_code_global: this.builder.control(this.expenseInfo.gl_acc_code_global, [Validators.required, Validators.maxLength(50)]),
      description: this.builder.control(this.expenseInfo.description)
    });

    this.editForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });
  }
  /**
   * Dirtyness check
   * @returns 
   */
  isDirty(): boolean {
    return this.isFormDirty;
  }

  /**
   * checks the form is edited
   */
  navBack(): void {

    this.router.navigate(['/system/expense-type']);

  }

  /**
   * If tas is is null set an empty expense info
   * if expense id is not null call api to rtrive the info
   * @param expenseId 
   */
  setExpenseInfo(expenseId: any): void {

    let response = this.expenseTypeService.getExpenseById(expenseId).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.expenseInfo = response.data.expense_type;
          this.editForm.patchValue(this.expenseInfo);
          this.isFormDirty = false;
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        let snackBarData: SnackBarData = {
          message: 'Failed to get data from server. Connection to the server failed.',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }

  /**
   * 
   * @returns  the title for the dialog
   * sine the same dialog is used for edit and new, dynamically decide the title
   */
  getTitle(): string {
    let title = (this.expenseInfo.id == 0 || this.expenseInfo.id == undefined) ? "New Expense Type" : "Editing : " + this.expenseInfo.name;
    return title;
  }

  /**
     * On save
     * if the details are valid call the api to update the changes.
     */
  save(): void {

    if (this.editForm.valid) {
      this.editForm.markAllAsTouched();
      Object.assign(this.expenseInfo, this.editForm.value);
      this.expenseTypeService.update(this.expenseInfo).subscribe({
        next: (response) => {
          if (response.status == 'SUCCESS') {
            // handle success
            this.isFormDirty = false;
            let snckBarData: SnackBarData = {
              type: 'success',
              title: 'Saved',
              message: 'The record for ' + this.expenseInfo.name + " has been updated succesfully."
            }
            this.snackBarService.openSnackBar(snckBarData);
            this.router.navigate(['/system/expense-type']);

          } else {
            let snackBarData: SnackBarData = {
              message: response.message,
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);


          }
        },
        error: (error) => {
          // handle error
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      });

    } else {
      this.editForm.markAllAsTouched();
    }
  }

}
